"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
exports.default = new Network_1.default('pilab-poa2', [
    new Token_1.default('ether', 'ETH', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} ETH', 'icon/eth.svg'),
    new Token_1.default('usdt', 'USDT', 'bifi', 1, '0xb6F09B20453CaaeA91a253098f3c5e186DC3F949', '', false, true, false, [], '{} USDT', 'icon/usdt.svg'),
    new Token_1.default('dai', 'DAI', 'bifi', 2, '0x6C9D0381cDa046577C5bCA97629507247312bD66', '', false, true, false, [], '{} DAI', 'icon/dai.svg'),
    new Token_1.default('link', 'LINK', 'bifi', 3, '0x2E6a7b8a2481062Fe9a9754d700e4f684100D8Cb', '', false, true, false, [], '{} LINK', 'icon/link.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 4, '0xD8Cad28398558deF9dB93FC77e6DF2936e767cd4', '', false, true, false, [], '{} USDC', 'icon/usdc.svg'),
    new Token_1.default('btc', 'BTC', 'bifi', 5, '0x9D9B2EC97dfAd3b21E8Ae5D2b7EcFe3A3FDD84fC', '', false, true, false, [], '{} BTC', 'icon/btc.svg'),
    new Token_1.default('dot', 'DOT', 'bifi', -1, '', '', true, true, true, [], '{} DOT', 'icon/dot.svg'),
    new Token_1.default('kaia', 'KAIA', 'bifi', -1, '', '', true, true, true, [], '{} KAIA', 'icon/kaia.svg'),
    new Token_1.default('bfc', 'BFC', 'stake.bfc', -1, '0xb0acAD322783f7F20279DF5BF8b959C8B85E8573', '', false, true, false, [], '{} BFC', 'icon/bfc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x533d9351f1E8A60CC4f0D7Db840628D5875404fb', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'ether'),
    new Handler_1.default(1, 'usdt'),
    new Handler_1.default(2, 'dai'),
    new Handler_1.default(3, 'link'),
    new Handler_1.default(4, 'usdc'),
    new Handler_1.default(5, 'btc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('bifi.btcUserInfo', 'getETHUserInfo(address)', ['user.address'], ['address[]']),
    new Method_1.default('bifi.refundAddr', 'getRefundAddr(address)', ['user.address'], ['address']),
    new Method_1.default('bifi.btcInflow', 'get_inflowPending(address)', ['user.address'], ['uint256']),
    new Method_1.default('bifi.btcOutflow', 'get_outflowInfo(address)', ['user.address'], ['(bool,uint64,uint128)']),
    new Method_1.default('bifi.btcChallenge', 'challengeCTX()', [], ['(bool,uint64,uint64,bytes32)']),
    new Method_1.default('bifi.btcSubmittedUnit', 'get_submittedUnit(bytes32)', ['unitID'], ['uint256']),
    new Method_1.default('bifi.btcConfirmGuarantee', 'Confirm_Guarantee()', [], ['uint256']),
    new Method_1.default('bifi.btcCurrentHeight', 'currentHeight()', [], ['uint256']),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionStatus(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x262dB41abE2e41d1373f13ee47D89d65E28E7b39'),
    new EntryPoint_1.default('bifi.resolver', '0xA29A386Cd33c91bF67DbdDEC1bfEf0f6568e5002'),
    new EntryPoint_1.default('bifi.btcdb', '0x1a6DeA2F0aDF5F1b60a73e5aEf159e4e66ADc9AC'),
    new EntryPoint_1.default('bifi.bitcoin', '0xBaCDe0F4130f9C65597436c040ceE06bD81e9a91'),
    new EntryPoint_1.default('xBifi', '0x63E43c772Ea2a6FfCE1FBd69FBD277a3144d8920'),
    new EntryPoint_1.default('xBifi.factory', '0x3542052f7dAc957973a848659aA1519B01C1e3F1')
], 3000);
//# sourceMappingURL=pilab-poa2.js.map